var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonChartListV(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-264 -160)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(267.75 168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.25,16.75H12a.75.75,0,0,1,0-1.5H23.25a.75.75,0,0,1,0,1.5Z",
    transform: "translate(-6.75 -9)",
    fill: "#6b8799"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.25,24.75H12a.75.75,0,0,1,0-1.5H23.25a.75.75,0,0,1,0,1.5Z",
    transform: "translate(-6.75 -12)",
    fill: "#6b8799"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5,16.75H5a.75.75,0,0,1,0-1.5H6.5a.75.75,0,0,1,0,1.5Z",
    transform: "translate(-5 -9)",
    fill: "#6b8799"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5,24.75H5a.75.75,0,0,1,0-1.5H6.5a.75.75,0,0,1,0,1.5Z",
    transform: "translate(-5 -12)",
    fill: "#6b8799"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4,16.75a.75.75,0,0,1-.379-1.4l6-3.5a.75.75,0,0,1,.713-.023l5.637,2.819,5.65-3.3a.75.75,0,0,1,.756,1.3l-6,3.5a.75.75,0,0,1-.713.023l-5.637-2.819-5.65,3.3A.747.747,0,0,1,4,16.75Z",
    transform: "translate(263 154)",
    fill: "#6b8799"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonChartListV);
export default __webpack_public_path__ + "static/media/ButtonChartListV.799c129e994c3621bcffa80cb46bd7c3.svg";
export { ForwardRef as ReactComponent };